var map = {
	"./Booking-icon.png": 5110,
	"./Dang_Pic.png": 1030,
	"./HomePage_background.png": 6576,
	"./Jonas_Pic.png": 1407,
	"./Maggie_Pic.png": 6820,
	"./Nancy_Pic.png": 621,
	"./SeniorCare_1.jpg": 1040,
	"./aboutus_background.webp": 7989,
	"./arrowIconLeft.jpg": 2448,
	"./arrowIconRight.jpg": 6745,
	"./arrowIconUp.jpg": 9652,
	"./avatar_placeholder.png": 4014,
	"./avatar_placeholder_0.png": 9267,
	"./avatar_placeholder_1.png": 9434,
	"./avatar_placeholder_2.png": 5681,
	"./avatar_placeholder_3.png": 7288,
	"./back_icon.png": 5444,
	"./book_consultation_icon.png": 1108,
	"./book_icon.png": 6682,
	"./booking_accepted_icon.webp": 6578,
	"./booking_denied_icon.png": 2320,
	"./booking_pending_icon.png": 8520,
	"./calendar_icon.png": 8301,
	"./care_service_1.png": 9256,
	"./care_service_2.png": 1363,
	"./care_service_3.png": 6154,
	"./care_service_4.png": 3029,
	"./care_service_5.png": 140,
	"./clock_icon.png": 4885,
	"./close_icon.png": 4503,
	"./coming_soon.png": 7902,
	"./completion-icon.png": 6439,
	"./consultation_background.png": 601,
	"./contactus_background.jpg": 5848,
	"./contactus_background.png": 8188,
	"./date-confirmed.png": 3455,
	"./display01.jpeg": 4861,
	"./display02.jpeg": 6572,
	"./display03.jpeg": 1827,
	"./display04.jpeg": 7730,
	"./display05.jpeg": 5385,
	"./footer-aboutus-img.png": 4864,
	"./google-icon.png": 9522,
	"./home_icon.png": 2168,
	"./house_icon.png": 6455,
	"./iCareVillage_logo.webp": 2321,
	"./invoice_icon.png": 1380,
	"./leadership-background.jpg": 8557,
	"./loading_icon.gif": 1196,
	"./login_background.jpg": 7033,
	"./logo-placeholder.jpg": 3286,
	"./menu_icon.png": 3040,
	"./more_info_icon.png": 7049,
	"./no-message-pic.png": 9467,
	"./nursing_background.jpeg": 1775,
	"./orientation_background.png": 6874,
	"./patient_icon.png": 8390,
	"./payment-icon.png": 6727,
	"./placeholder-avatar.png": 2576,
	"./placeholder_calendar_photo.jpg": 5014,
	"./placeholder_logo.png": 6400,
	"./provider-icon.png": 5256,
	"./provider_icon.png": 3330,
	"./provider_placeholder_1.png": 9470,
	"./provider_placeholder_2.png": 9829,
	"./provider_placeholder_3.png": 6940,
	"./search-icon.png": 5549,
	"./send-icon.png": 839,
	"./service_1.png": 2102,
	"./service_10.png": 5716,
	"./service_11.png": 1869,
	"./service_12.png": 1190,
	"./service_13.png": 9279,
	"./service_2.png": 3725,
	"./service_3.png": 3780,
	"./service_4.png": 5435,
	"./service_5.png": 1218,
	"./service_6.png": 1929,
	"./service_7.png": 7104,
	"./service_8.png": 1335,
	"./service_9.png": 3022,
	"./service_icon.png": 6508,
	"./show_button_icon.webp": 5001,
	"./show_more_icon.png": 1068,
	"./smallLoading.gif": 2239,
	"./submit-img.png": 9473,
	"./tick_icon.png": 810,
	"./trash-icon.png": 7816,
	"./under-construction.webp": 5635,
	"./visa-icon.png": 9352,
	"./wait-icon.png": 2780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;